<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aYNJW3/tc-custom/9780814346570.jpg?1723144608602" alt="This image is the cover for the book Woman Up, Contemporary Approaches to Film and Media Studies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Woman Up, Contemporary Approaches to Film and Media Studies
      </h1>
      <p class="bookDescription body article font2">
        <p> <b>Critically analyzes the discursive relationship between cultural value and popular feminism in American television.</b> </p><p>While American television has long relied on a strategic foregrounding of feminist politics to promote certain programming's cultural value, <i>Woman Up: Invoking Feminism in Quality Television</i> is the first sustained critical analysis of the twenty-first-century resurgence of this tradition. In <i>Woman Up</i>, Julia Havas'scentral argument is that postmillennial "feminist quality television" springs from a rhetorical subversion of the (much-debated) masculine-coded "quality television" culture on the one hand and the dominance of postfeminist popular culture on the other.</p><p>Postmillennial quality television culture promotes the idea of aesthetic-generic hierarchies among different types of scripted programming. Its development has facilitated evaluative academic analyses of television texts based on aesthetic merit, producing a corpus of scholarship devoted to pinpointing where value resides in shows considered worthy of discussion. Other strands of television scholarship have criticized this approach for sidestepping the gendered and classed processes of canonization informing the phenomenon. <i>Woman Up</i> intervenes in this debate by reevaluating such approaches and insisting that rather than further fostering or critiquing already prominent processes of canonization, there is a need to interrogate the cultural forces underlying them. Via detailed analyses of four TV programs emerging in the early period of the "feminist quality TV" trend—<i>30</i> <i>Rock (2006–13), Parks and Recreation</i>(2009–15),<i>The Good Wife</i> (2009–16), and<i>Orange Is the New Black</i> (2013–19)—<i>Woman Up</i> demonstrates that such series mediate their cultural significance by combining formal aesthetic exceptionalism and a politicized rhetoric around a "problematic" postfeminism, thus linking ideals of political and aesthetic value.</p><p> <i>Woman Up</i>will most appeal to students and scholars of cinema and media studies, feminist media studies, television studies, and cultural studies.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julia Havas
      </h2>
      
      <p class="authorDescription body article"><p>Julia Havas is lecturer in media at De Montfort University, Leicester. She has published in the journals <i>Television and New Media</i> and <i>Animation Studies</i> and contributed chapters to the anthologies <i>Hysterical! Women in American Comedy</i> and <i>Binge-watching and Contemporary Television Research</i>. Her research focuses on Anglo-American television, the gender and race politics of popular media, streaming culture, Hungarian film and TV, and the transcultural travel of media.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wayne State University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?49b3f110